import { Injectable } from '@angular/core';
import { map, concatMap} from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as widgetActions from '../actions/invoice-status-widget';
import { InvoiceStatusWidgetHttpService } from '@feature/invoice-status/services/invoice-status-widget-http.service';

@Injectable()
export class InvoiceStatusWidgetEffects {

  constructor(
    private readonly invoiceStatusWidgetHttp: InvoiceStatusWidgetHttpService,
    private readonly actions: Actions,
  ) { }

  load = createEffect(() => this.actions.pipe(
    ofType(widgetActions.apiLoad),
    concatMap(action => {
      return this.invoiceStatusWidgetHttp.getInvoiceData(
        action.widgetId,
        action.supplierRef,
        action.creditorUri,
        action.external).pipe(
          map(data => {
            return widgetActions.apiLoadComplete({ widgetId: action.widgetId, data: data });
          }
          )
        );
    })
  ));


}
